import { ReactNode } from 'react';

export interface ReminderConfig {
  id: string;
  reminderNumber: number;
  scheduleRelation: ScheduleRelation;
  days: number;
  reminderDate?: string;
  [key: string]: any; // Allow additional properties for custom columns
}

export enum ScheduleRelation {
  BEFORE = 'BEFORE',
  ON = 'ON',
  AFTER = 'AFTER'
}

export interface ReminderColumnConfig {
  key: string;
  label: string;
  width?: string;
  render: (reminder: ReminderConfig, onUpdate: (field: string, value: any) => void) => ReactNode;
}

export interface BaseReminderModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSave: (reminders: ReminderConfig[]) => void;
  onCancel?: () => void;
  title?: string;
  subtitle?: string;
  initialReminders?: ReminderConfig[];
  maxReminders?: number;
  customColumns?: ReminderColumnConfig[];
  showAddButton?: boolean;
  showDeleteButton?: boolean;
  isLoading?: boolean;
  renderValidationRow?: (reminder: ReminderConfig) => ReactNode;
  scheduleRelationsPriority?: ScheduleRelation[];
  onNewReminderCreate?: (reminder: ReminderConfig) => ReminderConfig;
  footerInfo?: ReactNode;
}
